import { Listbox } from "@headlessui/react";
import classNames from "classnames/bind";

import styles from "./SelectInput.module.scss";

const cx = classNames.bind(styles);

export interface SelectOption<TValue = string, TLabel = string> {
  label: TLabel;
  value: TValue;
  kind?: string;
}

export interface SelectInputProps {
  options: SelectOption[];
  selected?: SelectOption;
  onChange: (item: SelectOption) => void;
  buttonClassName?: string;
}

export const SelectInput = ({ options, selected, onChange, buttonClassName }: SelectInputProps) => {
  return (
    <div className={styles.selectWrapper}>
      <Listbox value={selected} onChange={onChange}>
        <Listbox.Button className={cx("input", buttonClassName)}>{selected?.label}</Listbox.Button>
        <Listbox.Options className={styles.list}>
          {options.map((option) => (
            <Listbox.Option className={styles.listItem} key={option.value} value={option}>
              {option.label}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </Listbox>
    </div>
  );
};
